import { GlobalConfigProvider } from 'domain/globalConfig/GlobalConfigContext';
import { ProfileConfigProvider } from 'domain/profileConfig/ProfileConfigContext';
import { CreateJobPostProvider } from 'domain/createJobPostConfig/CreateJobPostContext';

const providerList = [[GlobalConfigProvider], [ProfileConfigProvider], [CreateJobPostProvider]];

export const Providers = ({ children }) => {
  return providerList.reduce((acc, item) => {
    const [Provider, props] = item;

    if (props) return <Provider {...props}>{acc}</Provider>;

    return <Provider>{acc}</Provider>;
  }, children);
};
